import { Checkbox } from '@mui/material';
import React, { type CSSProperties, useRef, useState } from 'react';

import { updateState } from '../../helpers/helper';
import XDButton from '../buttons/XDButton';

interface props {
  children?: string | JSX.Element;
  /**
   * TODO: Rename to value
   */
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: CSSProperties;
  leftPadComponent?: JSX.Element;
  hasHyperlinks?: boolean;
  error?: boolean;
  helperText?: string[];
  disabled?: boolean;
}

interface State {
  isHover?: boolean;
}

export default function XDCheckbox(props: props) {
  const labelRef = useRef<HTMLLabelElement>(null);
  const [state, setState] = useState<State>({});

  const handleContentClick = (e: React.MouseEvent) => {
    // If hasHyperlinks is true, only prevent default for non-hyperlink elements
    if (props.hasHyperlinks) {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' || target.closest('a')) {
        // Allow hyperlink clicks to work normally
        e.stopPropagation();
        return;
      }
    }
    // For non-hyperlink clicks, toggle the checkbox
    e.preventDefault();
    e.stopPropagation();
    labelRef.current?.click();
  };

  // Declare the style as a variable
  const contentStyle: CSSProperties = {
    opacity: state.isHover ? 0.6 : 1
  };

  return (
    <XDButton
      className={'hover:bg-opacity-0'}
      style={{ ...props.style }}
      onMouseEnter={() => {
        updateState<State>({ isHover: true }, state, setState);
      }}
      onMouseLeave={() => {
        updateState<State>({ isHover: false }, state, setState);
      }}
      disabled={props.disabled}
    >
      <label
        ref={labelRef}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={'flex gap-2 items-start w-full cursor-pointer'}
        style={{ marginLeft: props.children ? '-1rem' : 0 }}
      >
        {(props.leftPadComponent ?? props.children) ? <div className={'w-0'} /> : <></>}
        <Checkbox
          checked={Boolean(props.checked)}
          value={Boolean(props.checked)}
          sx={{ '& .MuiSvgIcon-root': { fontSize: 24 }, padding: 0 }}
          disableRipple
          onChange={props.onChange}
          disabled={props.disabled}
        />
        {props.children && (
          <div
            className={`flex flex-col gap-2 w-full normal-case text-left ${
              props.hasHyperlinks ? 'pointer-events-auto' : 'pointer-events-none'
            }`}
            style={contentStyle}
            onClick={handleContentClick}
          >
            {props.children}
            {(props.helperText?.length ?? 0) > 0 && (
              <span className={'text-xs'} style={{ color: props.error ? 'rgb(211, 47, 47)' : 'inherit' }}>
                {props.helperText?.join('\n')}
              </span>
            )}
          </div>
        )}
      </label>
    </XDButton>
  );
}
